import { Grid } from "@material-ui/core";
import { useResultadoExercicioService } from "../../contexts/ResultadoExercicioContext";
import GainTotalRow from "./GainTotalRow";
import LossTotalRow from "./LossTotalRow";
import ReportTable from "./ReportTable";

const ReportDataGrid = () => {
  const {
    isGroupedByFinanceCategory,
    cachedMovementData,
    isConsolidated,
    cachedPeriodTotal,
  } = useResultadoExercicioService();

  if (!cachedMovementData.length) {
    return (
      <Grid item xs={12} style={{ marginBottom: 16 }} key={"empty-table"}>
        <ReportTable data={[]} emptyMessage="Sem Movimentação" />
      </Grid>
    );
  }

  return (
    <Grid item container>
      {isGroupedByFinanceCategory ? (
        <>
          {cachedMovementData.map((movement, movementIndex) => (
            <Grid item xs={12} style={{ marginBottom: 16 }} key={movementIndex}>
              <ReportTable
                data={movement}
                emptyMessage="Sem Movimentação"
                isConsolidated={isConsolidated}
                isGroupedByFinanceCategory={isGroupedByFinanceCategory}
              />
            </Grid>
          ))}
          {cachedPeriodTotal?.balance >= 0 ? (
            <GainTotalRow
              isFinal
              total={cachedPeriodTotal?.balance ?? "0,00"}
            />
          ) : (
            <LossTotalRow
              isFinal
              total={cachedPeriodTotal?.balance ?? "0,00"}
            />
          )}
        </>
      ) : (
        <Grid item xs={12}>
          <ReportTable
            data={cachedMovementData}
            emptyMessage="Sem Movimentação"
            isConsolidated={isConsolidated}
            isGroupedByFinanceCategory={isGroupedByFinanceCategory}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ReportDataGrid;
